module.exports = __webpack_public_path__ + "static/media/LandingPage1.84c8a934.jpeg";